import paymentsService from '@/modules/payments/services/paymentsService';
import logError from '@/utils/logError/logError';

let latestRequestId = 0;

const state = {
  summary: null,
  hasError: false,
};

const getters = {
  summary: (state) => state.summary,
  hasError: (state) => state.hasError,
};

const mutations = {
  setSummary(state, summary) {
    state.summary = summary;
  },
  setHasError(state, hasError) {
    state.hasError = hasError;
  },
};

const actions = {
  async fetchSummary({ commit }) {
    latestRequestId += 1;
    const requestId = latestRequestId;
    commit('setHasError', false);
    try {
      const summary = await paymentsService.fetchPaymentPlansSummary();
      if (requestId !== latestRequestId) return;
      commit('setSummary', summary);
    } catch (error) {
      if (requestId !== latestRequestId) return;
      commit('setHasError', true);
      logError('Failed to fetch the payment plans summary', error);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
